import React from 'react';
import './../../../Styles/Main/RentalPage/RentalOrderedBike.scss';


function RentalOrderedBike({ ...props }) {
   

   return (
      <div className='orderedBike__body'>
         <div className="orderedBike__image">
            <img src={"../image/" + props.image} alt=""/>
         </div>
         <div className="orderedBike__bikeName text">{props.name}</div>
         <div className="orderedBike__price color-text">{ props.price }</div>
      </div>
   );
}
export default RentalOrderedBike;